<div class="team-management-container">
  <div class="cards-grid">
    <emerald-card class="team-card">
      <div class="card-header">
        <emerald-icon
          icon="groups"
          color="{{ teamCards.iconColor }}"
          type="outlined"
        ></emerald-icon>
        <h3>{{ teamCards.myTeam }}</h3>
      </div>
      <div class="card-content">
        <ng-container *ngTemplateOutlet="donutTpl; context: { view: teamOverviewDonut }"></ng-container>
      </div>
    </emerald-card>

    <emerald-card class="team-card">
      <div class="card-header">
        <emerald-icon
          icon="person"
          color="{{ teamCards.iconColor }}"
          type="outlined"
        ></emerald-icon>
        <h3>{{ teamCards.employeeType }}</h3>
      </div>
      <div class="card-content">
        <ng-container *ngTemplateOutlet="donutTpl; context: { view: employeeTypeDonut }"></ng-container>
      </div>
    </emerald-card>

    <emerald-card class="team-card">
      <div class="card-header">
        <emerald-icon
          icon="insights"
          color="{{ teamCards.iconColor }}"
          type="outlined"
        ></emerald-icon>
        <h3>{{ teamCards.teamDemographics }}</h3>
      </div>
      <div class="card-content">
        <ng-container *ngTemplateOutlet="donutTpl; context: { view: demographicsDonut }"></ng-container>
      </div>
    </emerald-card>

    <emerald-card class="team-card diversity-card">
      <div class="card-header">
        <emerald-icon
          icon="link"
          color="{{ teamCards.iconColor }}"
          type="outlined"
        ></emerald-icon>
        <h3>{{ teamCards.quickLinks }}</h3>
      </div>
      <div class="card-content">
        <div class="quick-links-visual">
          <div class="ql-badge">
            <span class="ql-badge-value">{{ totalQuickLinks }}</span>
            <span class="ql-badge-label">LINKS</span>
          </div>
          <a href="javascript:void(0)" class="quick-link" (click)="quickLinksModalOpened = true">
            {{ teamCards.quickLinksText }}
          </a>
        </div>
      </div>
    </emerald-card>
  </div>
</div>

<ng-template #donutTpl let-view="view">
  <div class="donut-row">
    <div class="donut">
      <svg viewBox="0 0 72 72" class="donut-svg" aria-hidden="true">
        <circle class="donut-track" cx="36" cy="36" r="28"></circle>
        <ng-container *ngIf="!view.empty">
          <circle
            *ngFor="let seg of view.segments"
            class="donut-segment"
            cx="36"
            cy="36"
            r="28"
            [attr.stroke]="seg.color"
            [attr.stroke-dasharray]="seg.dashArray"
            [attr.stroke-dashoffset]="seg.dashOffset"
          ></circle>
        </ng-container>
      </svg>
      <div class="donut-center">
        <span class="donut-value">{{ view.centerValue }}</span>
        <span class="donut-label" *ngIf="view.centerLabel">{{ view.centerLabel }}</span>
      </div>
    </div>
    <div class="breakdown" *ngIf="view.items?.length">
      <div class="bd-tile" *ngFor="let item of view.items" [style.border-left-color]="item.color">
        <span class="bd-value" [style.color]="item.color">{{ item.value }}</span>
        <span class="bd-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</ng-template>

<!-- Quick Links Modal Overlay -->
<div class="ql-overlay" *ngIf="quickLinksModalOpened" (click)="quickLinksModalOpened = false">
  <div class="ql-modal" (click)="$event.stopPropagation()">
    <div class="ql-header">
      <span class="ql-title">{{ teamCards.quickLinks }}</span>
      <button class="ql-close" (click)="quickLinksModalOpened = false">&#x2715;</button>
    </div>
    <div class="ql-body">
      <div class="ql-column">
        <div class="ql-item" *ngFor="let link of quickLinksLeft">
          <img *ngIf="link.svgIcon" [src]="'assets/icons/' + link.icon + '.svg'" class="ql-svg-icon" alt="" aria-hidden="true" />
          <emerald-icon *ngIf="!link.svgIcon" [icon]="link.icon" color="#003F2D" type="outlined"></emerald-icon>
          <div class="ql-item-text">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="ql-link-name">{{ link.name }}</a>
            <span class="ql-link-desc">{{ link.description }}</span>
          </div>
        </div>
      </div>
      <div class="ql-divider"></div>
      <div class="ql-column">
        <div class="ql-item" *ngFor="let link of quickLinksRight">
          <img *ngIf="link.svgIcon" [src]="'assets/icons/' + link.icon + '.svg'" class="ql-svg-icon" alt="" aria-hidden="true" />
          <emerald-icon *ngIf="!link.svgIcon" [icon]="link.icon" color="#003F2D" type="outlined"></emerald-icon>
          <div class="ql-item-text">
            <a [href]="link.url" target="_blank" rel="noopener noreferrer" class="ql-link-name">{{ link.name }}</a>
            <span class="ql-link-desc">{{ link.description }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
